import Link from "next/link";
import * as React from "react";
import Image from "next/image";
import styles from "./styles.module.css";
import { Heading } from "@/components/Shared";

type InsuranceCard = {
	title: string;
	src: string;
};

type Icon = {
	color: string;
	src: string;
	alt: string;
	width: number;
	height: number;
};

const InsuranceCard: React.FC<{
	icon: Icon;
	card: InsuranceCard;
}> = ({ card, icon }) => {
	return (
		<div
			className={`${styles.panel} ${styles[`panel--${icon.color}`]} h-100 `}
			style={{ display: "flex", alignItems: "center", flexDirection: "column" }}
		>
			<div className={`${styles.panel__icon} mb-4`}>
				<Image
					src={icon.src}
					alt={icon.src}
					width={icon.width}
					height={icon.height}
				/>
			</div>
			<Heading variant={3} isBold={false} title={card.title} />
			<Link
				href={card.src}
				className="w-100"
				style={{
					display: "flex",
					alignItems: "center",
					flexDirection: "column",
					textDecoration: "none",
				}}
			>
				<button
					className="button button__gradient"
					name="load_more"
					type="button"
					style={{
						maxWidth: "200px",
						minWidth: "150px",
						marginTop: "15px",
					}}
				>
					Get Quotes
				</button>
			</Link>
		</div>
	);
};
export default InsuranceCard;
